<template>
  <div>
    <menuEdit></menuEdit>
  </div>
</template>

<script>
import menuEdit from "@/components/Menu.vue";

export default {
  components: {
    menuEdit
  }
};
</script>
